import React from 'react';
import PropTypes from 'prop-types';
import warningSign from '../../../assets/images/warning-sign-border.svg';
import projectHelper from '../../../services/ProjectHelper';
import {Environment} from '../../../const/environment';

class EnvironmentItem extends React.Component {

    render() {
        let {serverItem, project} = this.props;
        let currentTagId = project[serverItem.key + 'TagId'];
        let isLastTag = projectHelper.isLastTag(project, currentTagId);
        return (
            <div className="environment-item">
                {serverItem.key === Environment.Staging && <i className="icon icon-alan-development-playground-small"/>}
                {serverItem.key === Environment.Testing && <i className="icon icon-alan-testing-playground-small"/>}
                {serverItem.key === Environment.Production && <i className="icon icon-alan-production-playground-small"/>}
                {serverItem.name}
                {(serverItem.key === Environment.Production && isLastTag) &&
                <img className="environment-item__img" src={warningSign}/>}
            </div>
        );
    }
}

EnvironmentItem.propTypes = {
    serverItem: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired
};

export default EnvironmentItem;